import React from 'react';
import { useAuth } from '../context/AuthContext';
import { IoTimeOutline, IoLogOutOutline } from 'react-icons/io5';

function PendingValidationScreen() {
  const { logout, userData } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Error logging out", error);
    }
  };

  return (
    <div style={{
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh', 
      backgroundColor: '#f8fafc',
      padding: '20px',
      textAlign: 'center'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '24px',
        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)',
        maxWidth: '500px',
        width: '100%'
      }}>
        <IoTimeOutline size={80} color="#f59e0b" style={{ marginBottom: '20px' }} />
        
        <h1 style={{ color: '#0f172a', fontSize: '1.8rem', margin: '0 0 10px 0', fontWeight: '800' }}>
          Cuenta en Revisión
        </h1>
        
        <p style={{ color: '#475569', fontSize: '1.1rem', marginBottom: '30px', lineHeight: '1.5' }}>
          ¡Hola, <strong>{userData?.nombre?.split(' ')[0] || 'Residente'}</strong>! Tu registro ha sido exitoso. 
          Un administrador de tu condominio {userData?.tipoResidente === 'inquilino' ? 'o el titular de tu unidad ' : ''}está revisando tus datos. 
          En cuanto validen tu acceso, podrás entrar a la plataforma.
        </p>

        <div style={{ padding: '20px', backgroundColor: '#fef3c7', borderRadius: '12px', marginBottom: '30px' }}>
          <p style={{ margin: 0, color: '#92400e', fontWeight: '600' }}>
            Si crees que esto es un error o demora demasiado, por favor contacta a la administración directamente.
          </p>
        </div>

        <button 
          onClick={handleLogout}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            width: '100%',
            padding: '14px',
            backgroundColor: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#dc2626'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ef4444'}
        >
          <IoLogOutOutline size={20} />
          Cerrar Sesión
        </button>
      </div>
    </div>
  );
}

export default PendingValidationScreen;
